<template>
  <section class="octobus__section profile">
    <div :class="{ 'octobus__container': !isFullWidth }">
      <div class="octobus__columns content">
        <div class="octobus__column has-text-centered is-size-4">{{ $t('profile.title') }}</div>
      </div>
      <div class="octobus__columns content">
        <div class="octobus__column">
          <div class="octobus__field">
            <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="profile__firstname">
              {{$t('profile.firstname')}}
            </label>
            <p class="octobus__control has-icons-left has-icons-right">
              <input
                :class="{
                  'is-danger': errors.has('profile__firstname'),
                  'is-primary': !errors.has('profile__firstname') && fields['profile__firstname'] && fields['profile__firstname'].dirty
                }"
                v-validate="'max:50'"
                class="octobus__input is-medium"
                type="text"
                :placeholder="$t('profile.firstname')"
                id="profile__firstname"
                name="profile__firstname"
                v-model.trim="firstname"
              >
              <span class="octobus__icon is-small is-left">
                <font-awesome-icon
                  :icon="userIcon"
                />
              </span>
            </p>
            <p v-show="errors.has('profile__firstname')" class="octobus__help is-danger">{{ errors.first('profile__firstname') }}</p>
          </div>
        </div>
        <div class="octobus__column">
          <div class="octobus__field">
            <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="profile__lastname">
              {{$t('profile.lastname')}}
            </label>
            <p class="octobus__control has-icons-left has-icons-right">
              <input
                :class="{
                  'is-danger': errors.has('profile__lastname'),
                  'is-primary': !errors.has('profile__lastname') && fields['profile__lastname'] && fields['profile__lastname'].dirty
                }"
                v-validate="'max:50'"
                class="octobus__input is-medium"
                type="text"
                :placeholder="$t('profile.lastname')"
                id="profile__lastname"
                name="profile__lastname"
                v-model.trim="lastname"
              >
              <span class="octobus__icon is-small is-left">
                <font-awesome-icon
                  :icon="userIcon"
                />
              </span>
            </p>
            <p v-show="errors.has('profile__lastname')" class="octobus__help is-danger">{{ errors.first('profile__lastname') }}</p>
          </div>
        </div>
      </div>
      <div class="octobus__columns">
        <div class="octobus__column">
          <div class="octobus__field">
            <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="profile__email">
              {{$t('profile.email')}}
            </label>
            <p class="octobus__control has-icons-left has-icons-right">
              <input
                :class="{
                  'is-danger': errors.has('profile__email'),
                  'is-primary': !errors.has('profile__email') && fields['profile__email'] && fields['profile__email'].dirty
                }"
                v-validate="'email|max:50'"
                class="octobus__input is-medium"
                type="email"
                :placeholder="$t('profile.email')"
                id="profile__email"
                name="profile__email"
                v-model.trim="email"
              >
              <span class="octobus__icon is-small is-left">
                <font-awesome-icon
                  :icon="emailIcon"
                />
              </span>
            </p>
            <p v-show="errors.has('profile__email')" class="octobus__help is-danger">{{ errors.first('profile__email') }}</p>
          </div>
        </div>
        <div class="octobus__column">
          <div class="octobus__field is-horizontal">
            <div class="octobus__field-body">
              <div class="octobus__field is-expanded">
                <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="profile__phone">
                  {{$t('profile.phone')}}
                </label>
                <div class="octobus__field has-addons">
                  <p class="octobus__control">
                    <span class="octobus__select is-medium">
                      <select v-model="countryCode">
                        <option value="+38">+38</option>
                        <option value="+48">+48</option>
                        <option value="+49">+49</option>
                        <option value="+420">+420</option>
                        <option value="+55">+55</option>
                        <option value="+7">+7</option>
                          <option value="+31">+31</option>
                          <option value="+32">+32</option>
                          <option value="+33">+33</option>
                          <option value="+43">+43</option>
                          <option value="+34">+34</option>
                          <option value="+351">+351</option>
                          <option value="+41">+41</option>
                          <option value="+30">+30</option>
                          <option value="+355">+355</option>
                          <option value="+356">+356</option>
                          <option value="+357">+357</option>
                          <option value="+374">+374</option>
                          <option value="+381">+381</option>
                          <option value="+382">+382</option>
                          <option value="+385">+385</option>
                          <option value="+386">+386</option>
                          <option value="+387">+387</option>
                          <option value="+389">+389</option>
                          <option value="+39">+39</option>
                          <option value="+359">+359</option>
                          <option value="+36">+36</option>
                          <option value="+373">+373</option>
                          <option value="+375">+375</option>
                          <option value="+40">+40</option>
                          <option value="+421">+421</option>
                          <option value="+370">+370</option>
                          <option value="+371">+371</option>
                          <option value="+372">+372</option>
                          <option value="+44">+44</option>
                          <option value="+45">+45</option>
                          <option value="+46">+46</option>
                          <option value="+47">+47</option>
                          <option value="+353">+353</option>
                          <option value="+354">+354</option>
                          <option value="+358">+358</option>
                          <option value="+90">+90</option>
                      </select>
                    </span>
                  </p>
                  <p class="octobus__control is-expanded">
                    <input
                      :class="{}"
                      class="octobus__input is-medium"
                      type="tel"
                      :placeholder="$t('profile.phone')"
                      id="profile__phone"
                      name="profile__phone"
                      v-validate="''"
                      v-model="phone"
                      v-mask="mask"
                      @input="updatePhone($event.target.value)"
                    >
                  </p>
                </div>
                <p v-show="errors.has('profile__phone')" class="octobus__help is-danger">{{ errors.first('profile__phone') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="is-divider" :data-content="$t('profile.passwordSection')"></div>
      <div class="octobus__columns">
        <div class="octobus__column">
          <div class="octobus__field">
            <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="profile__password">
              {{$t('profile.password')}}
            </label>
            <p class="octobus__control has-icons-left has-icons-right">
              <input
                :class="{
                  'is-danger': errors.has('profile__password'),
                  'is-primary': !errors.has('profile__password') && fields['profile__password'] && fields['profile__password'].dirty
                }"
                v-validate="'min:6'"
                class="octobus__input is-medium"
                type="password"
                :placeholder="$t('profile.password')"
                id="profile__password"
                name="profile__password"
                v-model.trim="password"
              >
              <span class="octobus__icon is-small is-left">
                <font-awesome-icon
                  :icon="passwordIcon"
                />
              </span>
            </p>
            <p v-show="errors.has('profile__password')" class="octobus__help is-danger">{{ errors.first('profile__password') }}</p>
          </div>
        </div>
        <div class="octobus__column">
          <div class="octobus__field">
            <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="profile__cpassword">
              {{$t('profile.cpassword')}}
            </label>
            <p class="octobus__control has-icons-left has-icons-right">
              <input
                :class="{
                  'is-danger': errors.has('profile__cpassword'),
                  'is-primary': !errors.has('profile__cpassword') && fields['profile__cpassword'] && fields['profile__cpassword'].dirty
                }"
                v-validate="'confirmed:profile__password|min:6'"
                class="octobus__input is-medium"
                type="password"
                :placeholder="$t('profile.cpassword')"
                id="profile__cpassword"
                name="profile__cpassword"
                v-model.trim="cpassword"
              >
              <span class="octobus__icon is-small is-left">
                <font-awesome-icon
                  :icon="passwordIcon"
                />
              </span>
            </p>
            <p v-show="errors.has('profile__cpassword')" class="octobus__help is-danger">{{ errors.first('profile__cpassword') }}</p>
          </div>
        </div>
      </div>
      <div class="octobus__columns">
        <div class="octobus__column is-offset-9 is-3">
          <button
            class="octobus__button is-primary is-fullwidth is-medium"
            :class="{'is-loading': loading}"
            @click="onSubmit"
            :disabled="!isDirty"
          >{{ $t('profile.saveBtn') }}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faUser, faKey, faEnvelope } from '@fortawesome/fontawesome-free-solid';
import AwesomeMask from 'awesome-mask';
import api from '@/api';
import { getMask, getCountryCode } from '@/utils/utils';

export default {
  name: 'Profile',
  components: {
    FontAwesomeIcon,
  },
  directives: {
    mask: AwesomeMask,
  },
  data() {
    return {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      countryCode: '+38',
      error: {},
      id: '',
      password: '',
      cpassword: '',
      isDirty: false,
      loading: false,
    };
  },
  mounted() {
    const { name, surname, email, phone, id } = this.$userData || this.$EventBus.$userData || {};
    const phoneObj = getCountryCode(phone);

    this.firstname = name;
    this.lastname = surname;
    this.email = email;
    this.countryCode = phoneObj.country;
    this.phone = phoneObj.phone;
    this.id = id;
  },
  computed: {
    mask() {
      const phone = this.countryCode;
      const mask = getMask(phone);

      return mask;
    },
    userIcon() {
      return faUser;
    },
    emailIcon() {
      return faEnvelope;
    },
    passwordIcon() {
      return faKey;
    },
    phoneNumber() {
      return this.countryCode + this.phone;
    },
    isFullWidth() {
      return this.$fullwidth;
    },
  },
  watch: {
    firstname() {
      this.isDirty = this.isChange();
    },
    lastname() {
      this.isDirty = this.isChange();
    },
    email() {
      this.isDirty = this.isChange();
    },
    countryCode() {
      this.isDirty = this.isChange();
    },
    phone() {
      this.isDirty = this.isChange();
    },
    password() {
      this.isDirty = this.isChange();
    },
    cpassword() {
      this.isDirty = this.isChange();
    },
  },
  methods: {
    updatePhone(value) {
      const formattedValue = value.trim().replace(/[^+\d]/g, '');
      this.phone = formattedValue;
      return true;
    },
    isChange() {
      return Object.keys(this.$validator.flags).some(item => this.$validator.flags[item].dirty);
    },
    async onSubmit() {
      const validateSignin = await this.$validator.validateAll();

      if (validateSignin === true && this.isDirty) {
        this.sendSignup();
        this.$validator.reset();
      }
    },
    errorSignup(res) {
      this.error = res.error;
    },
    successSignup() {
      this.$toasted.show(this.$t('profile.success'));
    },
    async sendSignup() {
      const { phoneNumber: phone, firstname: name, lastname: surname, password, email, viber, telegram, watsapp, skype, id } = this;
      const profile = {
        phone,
        name,
        surname,
        email,
        password,
        viber,
        telegram,
        watsapp,
        skype,
      };
      this.loading = true;

      try {
        const response = await api.Authentication.update(id, profile);

        if (response.error) {
          this.errorSignup(response);
        } else {
          this.successSignup();
        }
      } catch (e) {
        throw e;
      }

      this.loading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue